<template>
  <div class="stage2content">
    <!-- dočasne zakomentované, lebo nepovolil SFA -->
    <!-- <client-needs-record/> -->
    <div v-if="applications?.length !== 0" class="result-block-broker-app stage2">
      <div class="results-legend signed">
        <div
            class="break-40px"
        ></div>
        <div
            class="text-small wrap-100px"
        >
          ÚVER
        </div>
        <div
            class="text-small wrap-100px"
        >
          SAZBA
        </div>
        <div
            class="text-small wrap-50px"
        >
          SPLÁTKA
        </div>
        <div
            class="text-small wrap-50px"
        >
          POPLATOK
        </div>
        <div
            class="text-small wrap-100px"
        >
          SPLATNOSŤ
        </div>
        <div
            class="text-small wrap-50px"
        >
          FIX
        </div>
      </div>
      <mortgage-application-sign-item
        v-for="(application, index) in applications"
        v-if="application.stage !== 'zrusena'"
        :key="index"
        :application="application"
      />
    </div>
    <div v-if="applications?.length == 0" class="emptybox">
      <span class="blc-color MGright20px">Aby sa Vám zobrazil generátor žiadostí, je potrebné vybrať aspoň jednu banku pre klienta v prvom kroku VÝBER</span>
    </div>
  </div>
</template>

<script>
import MortgageApplicationSignItem from "../ApplicatioinSign/MortgageApplicationSignItem";
// import ClientNeedsRecord from "./ClientNeedsRecord";

export default {
  name: "MortgageApplicationsSignWrapper",
  components: {
    // ClientNeedsRecord,
    MortgageApplicationSignItem
  },
  props: {
    applications: Array,
  },
}
</script>

<style scoped>
.emptybox{
  height: auto;
  width: 100%;
  padding-top: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
